import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly cmsTokenKey = 'cms_token';
  private readonly appTokenKey = 'app_token';

  constructor(private router: Router, private toastr: ToastrService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(environment.apiUrl)) {
      return next.handle(req);
    }

    const isPublic = req.url.includes('/public/');
    if (isPublic) {
      return next.handle(req);
    }

    const isPrivateCms = req.url.includes('/private/cms/');
    const isPrivateApp = req.url.includes('/private/app/');

    let token: string | null = null;

    if (isPrivateCms) token = this.getToken(this.cmsTokenKey);
    else if (isPrivateApp) token = this.getToken(this.appTokenKey);

    const authReq =
      token && (isPrivateCms || isPrivateApp)
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;

    return next.handle(authReq).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse && err.status === 401 && (isPrivateCms || isPrivateApp)) {
          this.toastr.error('Sua sessão expirou. Faça login novamente.');
          localStorage.removeItem(this.cmsTokenKey);
          localStorage.removeItem(this.appTokenKey);

          this.router.navigate(['/account/login']);
        }
        return throwError(() => err);
      })
    );
  }

  private getToken(key: string): string | null {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const token = raw.replace(/^Bearer\s+/i, '').trim();
    return token || null;
  }
}
